'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'square-6';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e25b';
var svgPathData = ['M32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96zM152 224c0-35.3 28.7-64 64-64l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-17.7 0-32 14.3-32 32l0 8.6c9.4-5.4 20.3-8.6 32-8.6l16 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-64zm32 64c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0c-17.7 0-32 14.3-32 32z', 'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm264 80c0 8.8-7.2 16-16 16l-32 0c-17.7 0-32 14.3-32 32l0 8.6c9.4-5.4 20.3-8.6 32-8.6l16 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l32 0c8.8 0 16 7.2 16 16zM216 320l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSquare6 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;